/* Determines how to open a feed item: in-app reader for articles, new tab for others. */

import type { NavigateFunction } from "react-router-dom";

export function openFeedItem(
  item: { _id: string; link: string; contentType?: string },
  navigate: NavigateFunction
) {
  if (item.contentType === "article") {
    navigate(`/article/${item._id}`);
  } else {
    window.open(item.link, "_blank");
  }
}
